import {emoji, nonUTF8Characters} from '~/constants/RegexConstants';

export function lines(text, maxLines) {
  return Math.min(text.split(/\r\n|\r|\n/).length, maxLines);
}

export function stringHasEmoji(string) {
  return emoji.test(string);
}

export function stringHasForeignCharacter(string) {
  return stringHasOffendingCharacter(string) && !stringHasEmoji(string);
}

export function stringHasOffendingCharacter(string) {
  return nonUTF8Characters.test(string);
}

export function scrubOffendingCharacters(string) {
  return string.replace(new RegExp(nonUTF8Characters, 'g'), '');
}

export function replaceSmartQuotes(string) {
  return string.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
}

export function sanitizeSearchText(string) {
  return string
    .replace(/[^\w\d'.]+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}

export function listify(strings) {
  if (strings.length > 2) {
    const last = strings[strings.length - 1];
    const secondToLast = strings[strings.length - 2];
    const start = strings.slice(0, strings.length - 2);
    return start.join(', ') + `, ${secondToLast}` + ', and ' + last;
  } else {
    return strings.join(' and ');
  }
}

export const getIntegerValue = value => {
  if (!value) return 0;
  return parseInt(value.replace(/[^0-9]/g, '').replace(/^0+/, ''), 10) || 0;
};
